import KundportalLogo from '@/components/KundportalLogo';
import { Box } from 'ui/mui';

type SimpleLayoutWithLogoProps = {
  children: React.ReactNode;
};

const SimpleLayoutWithLogo = ({ children }: SimpleLayoutWithLogoProps) => (
  <Box
    sx={(theme) => ({
      background: theme.palette.background.paper,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    })}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'end' },
        pt: 2,
        pr: { xs: 0, sm: 8 },
      }}
    >
      <KundportalLogo sx={{ height: 40 }} />
    </Box>
    <Box
      sx={{
        pt: { xs: 1, sm: 8 },
        flex: '1 0 auto',
        display: 'flex',
      }}
    >
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto',
          mt: 0,
          px: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  </Box>
);

export default SimpleLayoutWithLogo;
